import ApplicationLogo from '@/components/ApplicationLogo'
import AuthCard from '@/components/AuthCard'
import AuthSessionStatus from '@/components/AuthSessionStatus'
import Button from '@/components/Button'
import GuestLayout from '@/components/Layouts/GuestLayout'
import Input from '@/components/Input'
import InputError from '@/components/InputError'
import Label from '@/components/Label'
import Link from 'next/link'
import { useAuth, resetPasswordPath } from '@/hooks/auth'
import { useState } from 'react'
import { useRouter } from 'next/router'
import Header from '@/components/Layouts/Header'
import Head from 'next/head'
import Footer from '@/components/Layouts/Footer'

const ForgotPassword = () => {
    const router = useRouter()
    const { forgotPassword } = useAuth({
        middleware: 'guest',
        redirectIfAuthenticated: '/dashboard',
    })

    const [email, setEmail] = useState('')
    const [errors, setErrors] = useState([])
    const [status, setStatus] = useState(null)
    const [isSubmitting, setIsSubmitting] = useState(false)

    const submitForm = async event => {
        event.preventDefault()

        if (isSubmitting) return
        setIsSubmitting(true)

        try {
            const success = await forgotPassword({
                email,
                setErrors,
                setStatus,
            })
            if (success) {
                router.push(resetPasswordPath(email))
            }
        } finally {
            setIsSubmitting(false)
        }
    }

    return (
        <>
            <Head>
                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1.0"
                />
                <meta httpEquiv="X-UA-Compatible" content="ie=edge" />
                <title>Forgot Password - Smart Card Generator</title>
                <meta property="og:type" content="website" />
                <meta
                    property="og:url"
                    content="https://smartcardgenerator.net/forgot-password"
                />
                <meta
                    property="og:title"
                    content="Forgot Password - Smart Card Generator"
                />
                <meta property="og:site_name" content="Smart Card Generator" />
            </Head>
            <Header />
            <GuestLayout>
                <AuthCard
                    logo={
                        <Link href="/">
                            <ApplicationLogo className="w-20 h-20 fill-current text-gray-500" />
                        </Link>
                    }>
                    <div className="forget-page">
                        <div className="mb-4 text-sm text-gray-600">
                            Forgot your password? Enter your email and we will
                            send you a 6-digit reset code.
                        </div>

                        <AuthSessionStatus className="mb-4" status={status} />

                        <div className="login-wrapper">
                            <form onSubmit={submitForm}>
                                <div>
                                    <Label htmlFor="email" className={'text-start'}>
                                        Email
                                    </Label>
                                    <Input
                                        id="email"
                                        type="email"
                                        name="email"
                                        value={email}
                                        className="block mt-1 w-full"
                                        onChange={event =>
                                            setEmail(event.target.value)
                                        }
                                        required
                                        autoFocus
                                    />

                                    <InputError
                                        messages={errors.email}
                                        className="mt-2"
                                    />
                                </div>

                                <div className="flex items-center justify-end mt-4">
                                    <Button disabled={isSubmitting}>
                                        {isSubmitting
                                            ? 'Sending…'
                                            : 'Send Reset Code'}
                                    </Button>
                                </div>
                            </form>
                        </div>
                    </div>
                </AuthCard>
            </GuestLayout>
            <Footer />
        </>
    )
}

export default ForgotPassword
